<template>
  <v-flex>
    <modal>
      <template v-slot:headline>
        {{ $t('terms_of_use_modal_header') }}
      </template>
      <iframe width="100%" height="315" :src="`${getBasicStorageUrl()}tos/en/tos_latest.html`" style="border:none !important;" />
      <v-form v-model="valid" ref="form" @submit.prevent>
        <v-checkbox v-model="confirmed" :rules="needToBeChecked" :label="$t('terms_of_use_modal_checkbox')" color="primary" />
      </v-form>
      <template v-slot:buttons>
        <Button color="primary" :onClick="confirmTos" :buttonCanBeClicked="saveButtonCanbeClicked">{{ $t('terms_of_use_modal_checkbox') }}</Button>
      </template>
    </modal>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers('commonState');
import { getterTypes, actionTypes } from '@/views/common/store/common.moduletypes';

import { needToBeChecked } from '@/services/form.rules';

import Button from '@/components/ui/Button';
import Modal from '@/components/ui/Modal';

export default {
  components: {
    Button,
    Modal
  },
  data() {
    return {
      confirmed: false,
      valid: false,
      saveButtonCanbeClicked: true,
      needToBeChecked
    };
  },
  methods: {
    ...mapActions([actionTypes.acceptTos, actionTypes.getProfile]),
    getBasicStorageUrl() {
      return process.env.VUE_APP_STORAGE_URL;
    },
    confirmTos() {
      if (!this.$refs.form.validate()) return null;
      this.saveButtonCanbeClicked = false;

      this[actionTypes.acceptTos](this[getterTypes.getLastTosVersion])
        .then(() => {
          this[actionTypes.getProfile]().then(() => {
            this.saveButtonCanbeClicked = true;
          });
        })
        .catch(() => {
          this.saveButtonCanbeClicked = true;
        });
    }
  },
  computed: {
    ...mapGetters([getterTypes.getLastTosVersion])
  }
};
</script>
